import { injectable } from '~/container'
import { Route } from './Route'
import { RouterClient } from './RouterClient'

@injectable()
export abstract class RouteHistoryService extends RouterClient {
  abstract getHistory(): Route[]
  abstract getReferrer(): Route | undefined
}
